import {SmartComponent} from "smart-component-js";
import FormUtils from "../common/FormUtils";

import RSVP from "rsvp";
import LandingUrlBuilder from "../business/LandingUrlBuilder";

class FormBaseComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        params.className = "FormBaseComponent";
        super(element, parentComponent, params);

        this.$el = $(element);
    }

    init() {
        this.$el.find('[type="submit"]').click((e) => {
            if (!FormUtils.validateForm(this)) {
                e.preventDefault();
                console.log('Looooooooop!')
            }
            if (!FormUtils.validateFields(this.$el.find('input:visible, select:visible'))) {
                e.preventDefault();
                $("html, body").stop().animate({scrollTop: this.$el.find('.has-error:eq(0)').offset().top - 120}, 500, 'swing');
            } else if (!this.allowSubmit) {
                e.preventDefault();
                this.allowSubmit = true;
                FormUtils.showLoader(this.$el);

                FormUtils.doCaptcha(e, this.$el, this.$urlBackField, this.formType);
            }
        });
        FormUtils.addFormListeners(this.$el);

        this.$degreeLevelField.change(() => {
            this.$el.find('.course-info-msection').hide();
            this.$degreeLevel.val('');
            this.$course.val('');
            this.$course.data('courseLabel', null);
            this.$intake.val('');
            this.$campus.val('');

            this.selectedDegreeLevel = this.$degreeLevelField.val();
            let dlKey = this.$degreeLevelField.find('option:selected').attr('value') || '';
            let dlName = this.$degreeLevelField.find('option:selected').data('dlName') || '';
            this.$degreeLevel.val(dlKey);

            if (!!dlKey) {
                this.showCourseSelector(dlName);
            }
        });

        this.manageNormal();
        this.manageGeneral();
    }

    manageNormal() {
        this.$el.on('change', '#course-info-complete #area-input', (e) => {
            this.$el.find('#intake-input').html(KD_NABA_PAGE_CONSTANTS.EMPTY_INTAKE_OPTION);

            this.$course.val('');
            this.$course.data('courseLabel', null);
            this.$intake.val('');
            this.$campus.val('');
            let area = $(e.currentTarget).val();
            let html = KD_NABA_PAGE_CONSTANTS.EMPTY_COURSE_OPTION;
            html += `<optgroup label="">`;
            for (let i in this.normaAreaToCourses[area]) {
                let c = this.normaAreaToCourses[area][i];
                html += `<option value="${c.idSf}" data-label-edition="${c.label}" data-id-edition="${c.idEdition}" ${!c.labelUrl ? '' : `data-label-url="${c.labelUrl}"`}>${c.label}</option>`;
            }
            html += `</optgroup>`;
            this.$el.find('#course-info-complete #course-input').html(html);
        });

        this.$el.on('change', '#course-info-complete #course-input', (e) => {
            FormUtils.showLoader(this.$el);

            this.$intake.val('');

            let idCourse = $(e.currentTarget).val();
            this.$course.val(idCourse);
            let selectedOption = $(e.currentTarget).find('option:selected');
            let courseLabel = selectedOption.data('labelUrl');
            if (!courseLabel) {
                courseLabel = selectedOption.text();
            }
            this.$course.data('courseLabel', courseLabel);
            let idEdition = selectedOption.data('idEdition');
            let labelEdition = selectedOption.data('labelEdition');
            let campus = this.normalCoursesToCampus[idCourse];
            this.$campus.val(campus.idSf);

            this.$course.attr('label', labelEdition);

            FormUtils.loadIntake(campus.id, this.selectedDegreeLevel, this.formType, idEdition).then((data) => {
                let html = KD_NABA_PAGE_CONSTANTS.EMPTY_INTAKE_OPTION;
                for (let c in data) {
                    let intake = data[c];
                    html += `<option value="${intake.idsalesforce}">${intake.label}</option>`;
                }

                this.$el.find('#intake-input').html(html);
                FormUtils.hideLoader(this.$el);
            });
        });

        this.$el.on('change', '#course-info-complete #intake-input', (e) => {
            this.$intake.val($(e.currentTarget).val());
        });
    }

    manageGeneral() {
        this.$el.on('change', '#course-info-general #generalcampus', (e) => {
            FormUtils.showLoader(this.$el);

            let campusId = $(e.currentTarget).val();
            this.$intake.val('');

            this.$campus.val((this.generalCourse.campus));

            FormUtils.loadIntake(campusId, this.selectedDegreeLevel, this.formType, this.generalCourse.idEdition).then((data) => {
                let intake = data[0];
                this.$intake.val(intake.idsalesforce);
                FormUtils.hideLoader(this.$el);
            });
        });
    }

    showCourseSelector(dlName) {
        FormUtils.showLoader(this.$el);
        this.normaAreaToCourses = {};
        this.normalCoursesToCampus = {};
        FormUtils.loadCourses(this.formType, this.selectedDegreeLevel).then((data) => {
            this.$el.find('#course-info-complete #course-input').html(KD_NABA_PAGE_CONSTANTS.EMPTY_COURSE_OPTION);
            this.$el.find('#intake-input').html(KD_NABA_PAGE_CONSTANTS.EMPTY_INTAKE_OPTION);
            let html = KD_NABA_PAGE_CONSTANTS.EMPTY_AREA_OPTION;
            let showGeneral = true;
            let generalCourses = [];
            let firstKey = null;

            //Se è un foundation le aree sono fake, quindi metto tutto assieme nella stessa area.
            if ('Foundation' == dlName) {
                for (let area in data) {
                    if (!firstKey) {
                        if (!!data[area].result) {
                            firstKey = area;
                        } else {
                            delete data[area];
                        }
                    } else {
                        data[firstKey].result = data[firstKey].result.concat(data[area].result);
                        delete data[area];
                    }
                }
            }

            for (let area in data) {
                if (!!data[area].result) {
                    html += `<option value="${area}">${area}</option>`;
                    for (let i in data[area].result) {
                        let course = data[area].result[i];
                        course.area = area;
                        if (!course.general) {
                            this.manageCourse(course);
                            showGeneral = false;
                        } else {
                            generalCourses.push(course);
                        }
                    }

                    if (showGeneral || !!window.forceGeneral) {
                        this.showGeneralCourseSelection(data, generalCourses);
                        break;
                    }
                }
            }

            if (!showGeneral) {
                this.$el.find('#course-info-complete #area-input').parents('.form-input').toggle('Foundation' != dlName)
                this.$el.find('#course-info-complete #area-input').html(html);
                this.$el.find('#course-info-complete').show();

                //Se è foundation ho solo un'area quindi la nascondo e la seleziono
                if ('Foundation' == dlName) {
                    this.$el.find('#course-info-complete #area-input').val(firstKey);
                    this.$el.find('#course-info-complete #area-input').change();
                }

                FormUtils.hideLoader(this.$el);
            }
        });
    }

    manageCourse(course) {
        if (!this.normaAreaToCourses[course.area]) {
            this.normaAreaToCourses[course.area] = [];
        }
        this.normaAreaToCourses[course.area].push({
            label: course.label,
            labelUrl: course.labelUrl,
            idSf: course.idSalesforce,
            idEdition: course.idEdition
        });

        if (!this.normalCoursesToCampus[course.idSalesforce]) {
            this.normalCoursesToCampus[course.idSalesforce] = [];
        }
        this.normalCoursesToCampus[course.idSalesforce] = {
            id: course.idCampus,
            idSf: course.campus
        };
    }

    showGeneralCourseSelection(data, generalCourses) {
        let course = generalCourses[0];

        this.$course.val((course.idSalesforce));
        this.$course.data('courseLabel', course.labelUrl);
        this.generalCourse = course;

        this.$el.find('#generalcampus option').hide();
        for (let i in generalCourses) {
            let opt = this.$el.find('#generalcampus option[value="' + generalCourses[i].campus + '"]');
            if (opt.length > 0) {
                opt.show();
            }
        }

        this.$el.find('#course-info-general').show();
        FormUtils.hideLoader(this.$el);
    }

}

export default FormBaseComponent;